<template>
  <div>
    <div class="label-field" :class="dataOption.anchorLink && dataOption.anchorLink.status ? 'help-guide' : ''" v-if="dataOption.type === 'label'">
      <span v-html="dataOption.label"></span>
      <div v-if="dataOption.anchorLink && dataOption.anchorLink.status" class="help-guide"> 
        <a v-tipped data-tooltip="View User Guide" @click.prevent="$emit('action',{type:'modalLink', data:dataOption.anchorLink.id} )" :href="`#${dataOption.anchorLink.id}`">
          <i class="material-icons-outlined grey-text text-darken-4">help_outlined</i>
        </a>
      </div>
    </div>
    <div class="input-field" v-if="dataOption.type ==='text'">
      <input
        :disabled="globalDisabled || dataOption.readonly"
        type="text"
        v-bind:class="[!dataOption.v ? '' : $v.$invalid ? ' invalid' : ' valid']"
        :id="dataOption.name.toLowerCase()"
        :name="dataOption.name.toLowerCase()"
        v-model="values"
      />
      <label :for="dataOption.name.toLowerCase()">{{dataOption.label}}</label>
      <span class="helper-text" v-if="dataOption.helperText" :data-error="dataOption.helperText.e" :data-success="dataOption.helperText.s" >
        {{dataOption.helperText.d}}
      </span>
    </div>
    <!-- -->

      <div class="input-field" v-if="dataOption.type ==='email'">
      <input
        :disabled="globalDisabled || dataOption.readonly"
        type="email"
        v-bind:class="[!dataOption.v ? '' : $v.$invalid ? ' invalid' : ' valid']"
        :id="dataOption.name.toLowerCase()"
        v-model="values"
      />
      <label :for="dataOption.name.toLowerCase()">{{dataOption.label}}</label>
      <span class="helper-text" v-if="dataOption.helperText" :data-error="dataOption.helperText.e" :data-success="dataOption.helperText.s" >
        {{dataOption.helperText.d}}
      </span>
    </div>
    <!-- -->

    <div class="input-field" v-if="dataOption.type ==='url'">
      
      <input
        type="url"
        :disabled="globalDisabled || dataOption.readonly"
        v-bind:class="[!dataOption.v ? '' : dataOption.values && dataOption.values.split('').length > 3 ? 'validate' : 'invalid']"
        :id="dataOption.name.toLowerCase()"
        v-model="values"
      />
      <label :for="dataOption.name.toLowerCase()">{{dataOption.label}}</label>
    </div>
    <!-- -->
    <div class="input-field" v-if="dataOption.type ==='number'">
      
      <input
        type="number"
        :min="dataOption.min ? dataOption.min : 0"
        v-bind:class="[!dataOption.v ? '' : $v.$invalid ? ' invalid' : ' valid']"
        :max="dataOption.max ? dataOption.max : ''"
        :disabled="globalDisabled || dataOption.readonly"
        :id="dataOption.name.toLowerCase()"
        :name="dataOption.name.toLowerCase()"
        v-model="values"
      />
       <span class="helper-text" v-if="dataOption.helperText" :data-error="dataOption.helperText.e" :data-success="dataOption.helperText.s" >
        {{dataOption.helperText.d}}
      </span>
      <label :for="dataOption.name.toLowerCase()">{{dataOption.label}}</label>
    </div>
    <!-- -->
    <div class="input-field" v-if="dataOption.type ==='tel'">
      <input
        type="tel"
        :disabled="globalDisabled || dataOption.readonly"
        v-bind:class="[!dataOption.v ? '' : dataOption.values && dataOption.values.split('').length > 3 ? 'validate' : 'invalid']"
        :id="dataOption.name.toLowerCase()"
        v-model="values"
      />
      <label :for="dataOption.name.toLowerCase()">{{dataOption.label}}</label>
    </div>
    <!-- -->
 <!--    <div class="input-field" v-if="dataOption.type ==='email'">
      <input
        :disabled="globalDisabled  || dataOption.readonly"
        type="email"
        class="validate"
        :id="dataOption.name.toLowerCase()"
        v-model="values"
      />
      <label :for="dataOption.name.toLowerCase()">{{dataOption.label}}</label>
    </div> -->
    <!-- -->
    <select-field
    :data-disabled="globalDisabled  || dataOption.readonly"
    @update="$_emitOptions($event)"
      v-if="dataOption.type ==='select'"
      :dataOptions="dataOption"
      :data-valid="!$v.$invalid"
      :data-class="!dataOption.v ? '' : $v.$invalid ? 'invalid' : 'valid'"
    >
    </select-field>
    <!-- -->
    <div class="input-field" v-if="dataOption.type ==='text_area'">
      <textEditor @input="values = $event" v-model="values" :content="values" />
     <!--  <textarea              
      :disabled="globalDisabled || dataOption.readonly"
        class="materialize-textarea"
         v-bind:class="[!dataOption.v ? '' : $v.$invalid ? ' invalid' : ' valid']"
        :id="dataOption.name.toLowerCase()"
        v-model="values"
      ></textarea> -->
      <label :for="dataOption.name.toLowerCase()">{{dataOption.label}}</label>
      <span class="helper-text" v-if="dataOption.helperText" :data-error="dataOption.helperText.e" :data-success="dataOption.helperText.s" >
        {{dataOption.helperText.d}}
      </span>
    </div>
    <!-- -->
    <div class="col s12"  v-if="dataOption.type ==='checkbox'">
      <slot></slot>
      <div class="checkbox-label" v-html="dataOption.label">
      </div>
      <div class="cb_items" v-if="dataOption.style==='single'">
        <p v-for="(cbox, index) in dataOption.options" v-bind:key="index *0.91">
          <label>
            <input @change="$_emitOptions(dataOption)" type="checkbox" v-model="checkBoxModal"  :value="cbox.value" />
            <span v-html="cbox.label"></span>
          </label>
        </p>
      </div>
    </div>
    <!-- -->
    <div class="col s12"  v-if="dataOption.type ==='radio'">
      <slot></slot>
      <div class="radio-label">
       {{dataOption.label}}
      </div>
      <div>
      <p class="col" v-for="(radio, index) in dataOption.options" v-bind:key="index * 0.9181">
        <label>
          <input type="radio" v-model="radioModel" @change="$_emitOptions($event)" :group="dataOption.id" :value="radio.value" />
          <span class="grey-text text-darken-3">{{radio.label}}</span>
        </label>
      </p>
      </div>
    </div>
    
    <person-company
    :data-disabled="globalDisabled"
    v-if="dataOption.type ==='model_select'"
    @user="$_userComponent($event)"
    :dataOptions="dataOption"
    ></person-company>

    <date-picker
      :default-date="dataOption.values"
      :data-disabled="globalDisabled"
      @date="$_updateDateProps($event)"
      v-if="dataOption.type === 'date'"
    >
    {{dataOption.label}}
    </date-picker>

    <file-upload
      :data-content="dataOption"
      :is-multiple="dataOption.isMultiple"
      @files="$_fileUploads($event)"
      v-if="dataOption.type === 'file_upload'">
     {{dataOption.label}}
    </file-upload>

    <ro-rep
      :global-disabled="globalDisabled"
      @update="$_routerComp($event)"
      v-if="dataOption.type === 'custom_array'"
      :data-props="dataOption" >
    </ro-rep>
    <data-table-field 
      @update="$_updateOption"
     v-if="dataOption.type === 'data_table'"
     :data-option="dataOption"
      :global-disabled="globalDisabled"/>

    <contents-repeat
      :repeater-type="dataOption.entryFieldType"
      :data-type="dataOption.dataType"
      :global-disabled="globalDisabled"
      :data-valid="!$v.$invalid"
      @update="$_recordContents($event)"
      v-if="dataOption.type === 'content_array'"
      :data-props="dataOption"
    >
    </contents-repeat>
    </div>
</template>
<script>
// import editable from "@/components/contentEditable.component"
// import selectField from '@/components/selectField.component'
// import datePicker from '@/components/forms/datePicker.component'
// import autoComplete from '@/components/forms/autoComplete.component'
import textEditor from "@/components/textEditor.component.vue"
import dataTableField from '@/components/records/fields/dataTableField.component'
import fileUpload from '@/components/records/fields/fileUpload.component'
import personCompany from '@/components/records/personCompany.component'
import datePicker from '@/components/records/fields/datePicker.component'
import selectField from '@/components/records/fields/selectField.component'
import roRep from '@/components/records/fields/routeRepeat.component'
import contentsRepeat from '@/components/records/fields/contentsRepeat.component.vue'
const cleanHTML = (e) => {
  let div = document.createElement("div")
  div.innerHTML = e

  return div.textContent
}
const debounce = (func, delay) => {
  let inDebounce
  return function() {
    const context = this
    const args = arguments
    clearTimeout(inDebounce)
    inDebounce = setTimeout(() =>
      func.apply(context, args)
    , delay)
  }
}
export default {
  name:'fieldTypes',
  props:{
    globalDisabled:{
      type:Boolean,
      default:false,
    },
    dataOption:{
      type:[Array, Object]
    }
  },
  components:{
    selectField,
    personCompany,
    contentsRepeat,
    roRep,
    fileUpload,
    dataTableField,
    datePicker,
    textEditor,
   // autoComplete,
   // datePicker,
   // editable,
  },
  data(){
    let vm = this
    return {
      checkBoxModal:vm.values ? vm.values : new Array,
      radioModel:'',
      radioMoldaArray:new Array
    }
  },
  mounted () {
    if (this.dataOption.type === 'radio' && this.dataOption.values) {
      this.radioModel = this.dataOption.values
    }
      if (this.dataOption.type === 'checkbox' && this.dataOption.values) {
      this.checkBoxModal = this.dataOption.values
    }
    setTimeout(() => {
         if(this.dataOption.v) this.$emit('validate', {key: this.dataOption.name, value: !this.$v.$invalid})
    }, 100);
  },
  computed:{
    values:{
      get(){
        return this.dataOption ? this.dataOption.values : ''
      },
      set:debounce(function(evt){
  
        if(this.dataOption.type === "!text_area") {
          let y = evt.replace(/[\W_]+/g," ");
          y = cleanHTML(y)
          this.$_emitSFData(y, this.dataOption.type)
         return 
        }
        //this.$emit('update',evt)
        this.$_emitSFData(evt, this.dataOption.type)
      }, 120)
    },
  },
  validations() {
    if (
      this.dataOption.v && this.dataOption.rule 
      ) {
      return {
        values: {...this.dataOption.rule},
      };
    }  else {
      return ''
    }
  },
  methods:{
    $_recordContents($event) {
       const payload = {
        name:this.dataOption.name,
        data:$event,
      }
      this.$emit('update', payload)
       if(this.dataOption.v) this.$emit('validate', {key: this.dataOption.name, value: !this.$v.$invalid})
    },
    $_routerComp($event){
      
      const payload = {
        name:this.dataOption.name,
        data:$event,
      }
      this.$emit('update', payload)
    },
    $_emitSFData(data, type){
      if(type === 'text' || type === 'number' || type === 'url' || type === 'text_area' || type === 'email'){
        let payload = {
          name:this.dataOption.name,
          data,
        }
       
      this.$emit('update', payload)
      }
      if(this.dataOption.v) this.$emit('validate', {key: this.dataOption.name, value: !this.$v.$invalid})
    },
    $_userComponent(evt){
      let payload = {
        data:evt, 
        name:this.dataOption.name,
      }
      this.$emit('update', payload) 
    },
    $_fileUploads(evt){
        let payload = {
        data:evt, 
        name:this.dataOption.name,
      }
      this.$emit('uploads', payload)
      
    },
    $_updateDateProps($event){
      this.$_emitOptions($event)
      if(this.dataOption.v) this.$emit('validate', {key: this.dataOption.name, value: !this.$v.$invalid})
    },
    $_emitOptions (e) {
      if(this.dataOption.type === 'select')
        {
          let payload = {
            name:this.dataOption.name,
            data:e.values,
            }
          this.$emit('update', payload) 
        }
      if(this.dataOption.type === 'date'){
        let payload = {
            name:this.dataOption.name,
            data:e.date,
            }
          this.$emit('update', payload) 
        }
    if(this.dataOption.type === 'radio') {
        let payload = {
          prop: this.dataOption.name,
          data: this.radioModel
        }
         this.$emit('update', payload) 
    }
    if(this.dataOption.type === 'checkbox') {
        let payload = {
          prop: this.dataOption.name,
          data: this.checkBoxModal
        }
         this.$emit('update', payload) 
    }
    // console.log(e, 'emitOptions')
    if(this.dataOption.v) this.$emit('validate', {key: this.dataOption.name, value: !this.$v.$invalid})
    },
    $_updateOption(evt){
      this.$emit('update',evt)
      if(this.dataOption.v) this.$emit('validate', {key: this.dataOption.name, value: !this.$v.$invalid})
    }
  }
}
</script>